<template>
  <div id="videos">
      <v-container>

        <span v-if="language==='RU'"><PageTitle :title="title_RU" class="mt-4" /></span>
        <span v-if="language==='EN'"><PageTitle :title="title_EN" class="mt-4" /></span>

          <v-layout row wrap align-center justify-center fill-height class="mt-4">
              <v-flex xs12 sm3>
                <VideoBlock :vid="vid1" />
              </v-flex>
              <v-flex xs12 sm3>
                <VideoBlock :vid="vid2" />
              </v-flex>
              <v-flex xs12 sm3>
                <VideoBlock :vid="vid3" />
              </v-flex>
              <v-flex xs12 sm3>
                <VideoBlock :vid="vid4" />
              </v-flex>                            
          </v-layout>   

          <v-layout row wrap align-center justify-center fill-height class="mt-4">
              <v-flex xs12 sm3>
                <VideoBlock :vid="vid5" />
              </v-flex>
              <v-flex xs12 sm3>
                <VideoBlock :vid="vid6" />
              </v-flex>
              <v-flex xs12 sm3>
                <VideoBlock :vid="vid7" />
              </v-flex>
              <v-flex xs12 sm3>
                <VideoBlock :vid="vid8" />
              </v-flex>                            
          </v-layout> 

          <v-layout row wrap align-center justify-center fill-height class="mt-4">
              <v-flex xs12 sm3>
                <VideoBlock :vid="vid9" />
              </v-flex>
              <v-flex xs12 sm3>
                <VideoBlock :vid="vid10" />
              </v-flex>
              <v-flex xs12 sm3>
                <VideoBlock :vid="vid11" />
              </v-flex>
              <v-flex xs12 sm3>
                <VideoBlock :vid="vid12" />
              </v-flex>                            
          </v-layout> 

      </v-container>
  </div>
</template>

<script>
import PageTitle from '@/components/PageTitle'
import VideoBlock from '@/components/VideoBlock'

  export default {
    name: 'Videos',
    components: { PageTitle, VideoBlock },
    data() {
      return {
        language: '',
        title_RU: 'Видео',
        title_EN: 'Videos',
        vid1: {
          name: 'F. Lehár: "Meine Lippe", Giuditta',
          pic: 'giuditta.jpg',
          url: '0Us_jl_x-h4',
          date: '',
          description: ''
        },
        vid2: {
          name: 'F. Lehár: "Zigeunerliebe", Ilona',
          pic: 'gipsy-baron.jpg',
          url: '7x6ZxEfJDaA',
          date: '',
          description: ''
        },        
        vid3: {
          name: 'E. Kálmán: "Die Csárdásfürstin", Silva',
          pic: 'silva.jpg',
          url: '_vINo35Mu5I',
          date: '',
          description: ''
        }, 
        vid4: {
          name: 'Vill-Lobos: "Bachianas Brasileiras 5"',
          pic: 'villa-lobos.jpg',
          url: 'Qeufyn1glTs',
          date: '',
          description: ''
        }, 
        vid5: {
          name: 'Piazzolla: "Ave Maria"',
          pic: 'piazzolla-ave-maria.jpg',
          url: 'BtTxUA7Nink',
          date: '',
          description: ''
        }, 
        vid6: {
          name: 'G. Gershvin: "Summertime"',
          pic: 'summertime.jpg',
          url: 'L7jIoEOkwTY',
          date: '',
          description: ''
        }, 
        vid7: {
          name: 'E. Kálmán: "Gräfin Mariza"',
          pic: 'mariza.jpg',
          url: 'X-KL1CdvRzA',
          date: '',
          description: ''
        }, 
        vid8: {
          name: 'G. Puccini: "Lauretta"',
          pic: 'lauretta.jpg',
          url: 'uNFhbOv8H5k',
          date: '',
          description: ''
        }, 
        vid9: {
          name: 'Videi Clip',
          pic: 'clip.jpg',
          url: 'Hx079jUSdpQ',
          date: '',
          description: ''
        }, 
        vid10: {
          name: 'Magic Violin',
          pic: 'violin.jpg',
          url: 'PITG_-V95NQ',
          date: '',
          description: ''
        }, 
        vid11: {
          name: 'Luzzi: "Ave Maria"',
          pic: 'luzzi.jpg',
          url: 'teSHd1Hu1TQ',
          date: '',
          description: ''
        }, 
        vid12: {
          name: 'Albinoni: Adagio',
          pic: 'albinoni.jpg',
          url: 'T4MypqDslLg',
          date: '',
          description: ''
        }        
      }
    },
    mounted(){
      if(localStorage.lang){
        this.language = localStorage.lang
      }
    }
  }
</script>

<style>
  .video-heading {
      margin-top: 0;
      font-family: 'Tangerine', sans-serif;
      font-size: 30px;
      min-height: 80px;
}
</style>
